import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { DateWiseConcession } from '../types';
import { IconButton, Typography } from '@mui/material';
import Icons from '../../../components/icons';
import { PaymentConcessionType } from '../../../enums';
import timeUtils from '../../../utils/timeUtils';

export const getDateWiseConcessionColumns = (
  dateWiseConcessionType: string,
  onEdit: (row: DateWiseConcession) => void,
  onDelete: (row: DateWiseConcession) => void
): GridColDef[] => {
  const concessionField =
    dateWiseConcessionType === PaymentConcessionType.DATE_WISE_PERCENTAGE
      ? 'percentage'
      : 'amount';
  return [
    {
      field: 'fromDate',
      headerName: 'From',
      minWidth: 150,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const date = timeUtils.formatToReadableDate(params.row.fromDate);
        return <Typography>{date}</Typography>;
      }
    },
    {
      field: 'toDate',
      headerName: 'To',
      minWidth: 150,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const date = timeUtils.formatToReadableDate(params.row.toDate);
        return <Typography>{date}</Typography>;
      }
    },
    {
      field: concessionField,
      headerName:
        dateWiseConcessionType === PaymentConcessionType.DATE_WISE_PERCENTAGE
          ? 'Percentage'
          : 'Amount',
      sortable: false,
      filterable: false,
      flex: 1
    },
    {
      field: 'edit',
      headerName: 'Edit',
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton onClick={() => onEdit(params.row)}>
          <Icons.EditBlackOutlined />
        </IconButton>
      )
    },
    {
      field: 'delete',
      headerName: 'Delete',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton onClick={() => onDelete(params.row)}>
          <Icons.Delete />
        </IconButton>
      )
    }
  ];
};
